import React from "react";

// Kandake Document Repository — shared badge primitives for the vault
// surfaces. Disclosure class + division scope + expiry are attribute-driven
// per the Locked Minimum Specification.

const CLASS_STYLES = {
  RESTRICTED: {
    label: "Restricted",
    style: { background: "hsl(347 72% 22% / 0.16)", color: "hsl(347 65% 62%)", border: "1px solid hsl(347 72% 22% / 0.45)" },
  },
  OPERATING_PROOF: {
    label: "Operating Proof",
    style: { background: "hsl(40 48% 32% / 0.16)", color: "hsl(40 55% 58%)", border: "1px solid hsl(40 48% 32% / 0.5)" },
  },
  DEAL_DELIVERY: {
    label: "Deal Delivery",
    style: { background: "hsl(190 42% 30% / 0.16)", color: "hsl(190 45% 58%)", border: "1px solid hsl(190 42% 30% / 0.5)" },
  },
};

export function DisclosureClassBadge({ value, className = "" }) {
  const cfg = CLASS_STYLES[value] || CLASS_STYLES.RESTRICTED;
  return (
    <span
      data-testid={`vault-class-badge-${value || "unknown"}`}
      className={`inline-flex items-center px-2 py-0.5 text-[11px] font-medium rounded whitespace-nowrap ${className}`}
      style={cfg.style}
    >
      {cfg.label}
    </span>
  );
}

const DIVISION_LABELS = {
  SHARED: "Shared",
  GFMP: "GFMP",
  GFMP_SYNC: "GFMP Sync",
  KINGSWORK: "Kingswork",
};

export function DivisionBadge({ value, className = "" }) {
  return (
    <span
      data-testid={`vault-division-badge-${value || "SHARED"}`}
      className={`inline-flex items-center px-2 py-0.5 text-[11px] rounded border border-border text-muted-foreground whitespace-nowrap ${className}`}
    >
      {DIVISION_LABELS[value] || value || "Shared"}
    </span>
  );
}

export function ExpiryBadge({ isExpired, expirationDate, className = "" }) {
  if (!expirationDate) return <span className="text-[11px] text-muted-foreground">—</span>;
  if (isExpired) {
    return (
      <span
        data-testid="vault-expired-badge"
        className={`inline-flex items-center px-2 py-0.5 text-[11px] font-medium rounded ${className}`}
        style={{ background: "hsl(0 60% 30% / 0.18)", color: "hsl(0 65% 62%)", border: "1px solid hsl(0 60% 30% / 0.5)" }}
      >
        Expired {String(expirationDate).slice(0, 10)}
      </span>
    );
  }
  return (
    <span className={`text-[11px] font-mono text-muted-foreground ${className}`}>
      {String(expirationDate).slice(0, 10)}
    </span>
  );
}
